<template>
  <div class="record">
    <AppNavbar title="全部转换订单" :zIndex="1000" :placeholder="true">
    </AppNavbar>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="getRecord"
    >
      <div class="record-list">
        <div
          class="record-item"
          v-for="(item, index) in recordList"
          :key="index"
        >
          <div class="i-top">订单号：{{ item.order_id }}</div>
          <div class="i-center">
            <div class="c-item">
              <div class="c-text">实付金额</div>
              <div class="c-num">{{ item.price }}</div>
            </div>
            <div class="c-item">
              <div class="c-text">转换积分</div>
              <div class="c-num">{{ item.integral }}</div>
            </div>
            <div class="c-item">
              <div class="c-text">转换状态</div>
              <div class="c-num">{{
                item.convert_status ? '已转换' : '失败'
              }}</div>
            </div>
          </div>
          <div class="i-bottom">转换时间：{{ item.created_at }}</div>
        </div>
      </div>
    </van-list>
  </div>
</template>
<script>
import AppNavbar from '@/components/app/nav-bar/index.vue'
export default {
  name: 'dounyin-integral-exchange-record',
  components: {
    AppNavbar
  },
  data() {
    return {
      recordList: [],
      loading: false,
      finished: false,
      page: 1
    }
  },
  watch: {
    $route(to, from) {
      if (
        (from.path == '/integral-exchange/exchange' ||
          from.path == '/integral-exchange/login') &&
        to.path == '/integral-exchange/record'
      ) {
        this.page = 1
        this.finished = false
        this.loading = false
        this.recordList = []
      }
    }
  },
  created() {
    this.checkLogin()
  },
  activated() {
    this.$http.bindPageUMA()
  },
  methods: {
    checkLogin() {
      this.gym_code = this.$http._getCookie('token')
      if (!this.gym_code && !this.$route.query.refresh) {
        let url = location.href
        let params = url.includes('?') ? '&refresh=1' : '?refresh=1'
        url = url + params
        location.href =
          'http://auth3.gymcity.com.cn/?auth=wegymer&scope=snsapi_userinfo&next=' +
          encodeURIComponent(url)
      }
    },
    getRecord() {
      let params = {
        page: this.page,
        limit: 20,
        token: this.$http._getCookie('dy-integral-token')
      }
      this.$http
        .getApp('api/v1/IntegralConversionCenter/convertLog', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.page++
            if (res.data.length) {
              this.recordList = this.recordList.concat(res.data)
            } else {
              this.finished = true
            }
          } else {
            this.finished = true
          }
        })
        .catch(() => {
          this.finished = true
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.record {
  min-height: 100vh;
  background-color: #f9f9f9;

  .record-list {
    padding: 16px;

    .record-item {
      background: #ffffff;
      border-radius: 8px;
      margin-bottom: 8px;

      .i-top {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.5);
        line-height: 17px;
        padding: 12px 16px 10px;
        border-bottom: 1px solid #e8e8e8;
      }

      .i-center {
        text-align: center;
        padding: 15px 0px 11px;
        display: flex;
        align-items: center;
        justify-content: space-around;

        .c-text {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.8);
          line-height: 17px;
          margin-bottom: 4px;
        }

        .c-num {
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 600;
          color: rgba(0, 0, 0, 0.8);
          line-height: 20px;
        }
      }

      .i-bottom {
        text-align: right;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.5);
        line-height: 17px;
        padding: 0px 13px 12px;
      }
    }

    .record-item:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
